import type { CheckConsentOptions, ConsentCategory } from './types';

const isBrowser = () => typeof window !== 'undefined';
const hasConsent = (category: ConsentCategory) =>
  window?.OnetrustActiveGroups?.split(',').includes(category) ?? false;

export async function checkConsent(
  category: ConsentCategory,
  options?: CheckConsentOptions,
): Promise<boolean> {
  if (!isBrowser()) return false;
  if (hasConsent(category)) return true;

  const pollIntervalMs = options?.pollIntervalMs ?? 1000;
  const timeoutMs = options?.timeoutMs ?? 5000;

  return new Promise<boolean>((resolve) => {
    const interval = setInterval(() => {
      if (hasConsent(category)) {
        clearInterval(interval);
        clearTimeout(timer);
        resolve(true);
      }
    }, pollIntervalMs);

    const timer = setTimeout(() => {
      clearInterval(interval);
      resolve(false);
    }, timeoutMs);
  });
}
